export const getAvailableStock = (value) => {
  const stock = Number(value);

  return Number.isFinite(stock) ? Math.max(0, stock) : 0;
};

export const normalizePositiveQuantity = (value, minimum = 1) => {
  const quantity = Number(value);

  return Number.isFinite(quantity) ? Math.max(minimum, quantity) : minimum;
};

export const clampQuantityToAvailableStock = (
  value,
  currentStock,
  minimum = 1,
) => {
  const availableStock = getAvailableStock(currentStock);

  if (availableStock < minimum) return 0;

  return Math.min(
    normalizePositiveQuantity(value, minimum),
    availableStock,
  );
};

export const isQuantityWithinAvailableStock = (
  value,
  currentStock,
  minimum = 1,
) => {
  const quantity = Number(value);
  const availableStock = getAvailableStock(currentStock);

  return (
    Number.isFinite(quantity) &&
    quantity >= minimum &&
    quantity <= availableStock
  );
};
